module.exports = __webpack_public_path__ + "img/tema-1-12.a9cb8f71.png";